import React from "react";
import {KeyDaysIcon,PTOIcon,SpecialEventIcon,UnavailableDaysIcon,AccomodationsIcon, IconStatus} from  '../../Resources/availabilityicon/AvailabilityIcons';
import classes from "./availabilitytypes.module.scss";
 const AvailabilityTypes = (props) => {
   let iconStyle = IconStatus.NORMAL;
    return (
        <div className={classes.icon_text_wrap}>
            <div className={classes.icon_text}>
                <KeyDaysIcon type={iconStyle}/>
              <p className={classes.label_text}>Key Days</p>
             </div> 
             <div className={classes.icon_text}>
                <SpecialEventIcon type={iconStyle}/>
              <p className={classes.label_text}>Special Events</p>
             </div> 
             <div className={classes.icon_text}>
                <PTOIcon type={iconStyle}/>
              <p className={classes.label_text}>Paid Time Off</p>
             </div> 
             <div className={classes.icon_text}>
                <UnavailableDaysIcon type={iconStyle}/>
              <p className={classes.label_text}>Unavailable Days</p>
             </div>
        </div>
    )
}

export default AvailabilityTypes;
